<template>
    <div v-if="state.total_similar_accounts" class="rounded-md bg-red-50 p-4">
        <div class="flex">
            <div class="ml-3 flex-1 md:flex md:justify-between">
                <p class="text-sm text-red-700"><strong>Warning!</strong> {{state.total_similar_accounts}} similarly named account{{state.total_similar_accounts == 1 ? '' : 's'}} already exist{{state.total_similar_accounts == 1 ? 's' : ''}} for this auctioneer</p>
                <p class="mt-3 text-sm md:ml-6 md:mt-0">
                    <button type="button" class="whitespace-nowrap font-medium text-red-700 hover:text-red-600" v-on:click="() => state.similar_accounts_ui_active = !state.similar_accounts_ui_active">
                        Show similar accounts
                        <span aria-hidden="true"> &rarr;</span>
                    </button>
                </p>
            </div>
        </div>
    </div>
    <div v-if="state.similar_accounts_ui_active && state.similar_accounts.length > 0">
        <div class="my-4">
            <h3 class="text-sm font-semibold text-gray-900">Existing Accounts</h3>
            <p class="mt-1 max-w-2xl text-sm text-gray-500">Double check that you're not duplicating an account that already exists</p>
        </div>
        <ul role="list" class="divide-y divide-gray-100 overflow-hidden bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-md text-sm">
            <li v-for="(account, index) in state.similar_accounts" :key="index" class="py-4 px-6">
                <h3 class="flex-auto truncate text-sm/6 font-semibold text-gray-900">{{ account.name }} <span class="text-gray-500 font-medium">({{ account.code }})</span></h3>
            </li>
        </ul>
    </div>
</template>

<script>
import {computed, watch, onMounted, reactive, ref} from 'vue'
import { useAccountStore } from "@sto/account.store"
import { useAuctioneerStore } from '@sto/auctioneer.store'
export default {
    props: ['auctioneer_id', 'account_name', 'user_name', 'organisation_name'],
    setup(props, { emit }) {

        const ACCOUNT_STORE = useAccountStore()
        const AUCTIONEER_STORE = useAuctioneerStore()

        const state = reactive({
            account_check_loading: false,
            account_check_timeout: null,
            account_check_min_length: 3,
            similar_accounts: [],
            total_similar_accounts: 0,
            similar_accounts_ui_active: false
        })

        const getSimilarAccounts = async () => {

            if (!props.auctioneer_id || state.account_check_loading) return

            try {
                state.account_check_loading = true

                const similar_accounts = await ACCOUNT_STORE.list([{key: 'page', value: 1}, {key: 'per_page', value: 50}, {key: 'auctioneer_id', value: props.auctioneer_id}, {key: 'search_string', value: props.account_name }])

                state.similar_accounts = similar_accounts?.accounts || []
                state.total_similar_accounts = similar_accounts?.pagination?.total

            } catch (error) {
                console.error('ACCOUNT_STORE.list error', error)
                state.similar_accounts = []
                state.total_similar_accounts = 0

            } finally {
                state.account_check_loading = false
            }
        }

        watch (
            () => state.similar_accounts.length,
            () => {
                emit('similar_accounts_updated', state.similar_accounts.length)
            }
        )

        watch (
            () => props.account_name,
            () => {
                if (typeof props.account_name === 'string' && !props.account_name.length) {
                    // reset
                    state.similar_accounts = []
                    state.total_similar_accounts = 0
                    state.similar_accounts_ui_active = false
                }

                if (!props.auctioneer_id || props.account_name.length < state.account_check_min_length) return
                if (state.account_check_timeout) clearTimeout(state.account_check_timeout)
                state.account_check_timeout = setTimeout(getSimilarAccounts, 300)
            }
        )

        return {
            state
        }
    }
}
</script>